import {
  AbnormalSecurityIcon,
  ControlIcon,
  MimecastIcon,
  SettingsIcon,
  TaniumIcon,
} from "@theprelude/ds";
import { Node, NodeProps } from "@xyflow/react";
import { ComingSoonDataPoint } from "@/queries/control-monitor";
import { NodeBase } from "./node-base";

export type ComingSoonNodeType = Node<
  ComingSoonDataPoint,
  ComingSoonDataPoint["type"]
>;

const getIcon = (data: ComingSoonDataPoint) => {
  if (data.control !== undefined) {
    return <ControlIcon control={data.control} />;
  }

  switch (data.id) {
    case "abnormal": {
      return <AbnormalSecurityIcon />;
    }
    case "mimecast": {
      return <MimecastIcon />;
    }
    case "tanium": {
      return <TaniumIcon />;
    }
    default: {
      return <SettingsIcon />;
    }
  }
};

export const ComingSoonNode = ({ data }: NodeProps<ComingSoonNodeType>) => (
  <NodeBase
    nodeId={data.id}
    name={data.name}
    icon={getIcon(data)}
    hasParent
    hasChildren={data.children.length > 0}
    className="cursor-auto"
  >
    <div className="border-t border-stroke-line px-2 py-1 text-xs text-secondary-foreground">
      Coming Soon
    </div>
  </NodeBase>
);
